/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerievideoVideoidLangsIdQueryResponse,
  GetApiV1SerievideoVideoidLangsIdPathParams,
  GetApiV1SerievideoVideoidLangsIdQueryParams,
  GetApiV1SerievideoVideoidLangsId401,
  GetApiV1SerievideoVideoidLangsId404,
  GetApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangsId.ts";

function getGetApiV1SerievideoVideoidLangsIdUrl(
  videoId: GetApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: GetApiV1SerievideoVideoidLangsIdPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serievideo/${videoId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Retorna uma tradução (idioma) de vídeo pelo seu identificador. **(Requer Authorization para autenticação)**
 * @summary Obter idioma do vídeo por ID (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export async function getApiV1SerievideoVideoidLangsId(
  videoId: GetApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: GetApiV1SerievideoVideoidLangsIdPathParams["id"],
  params?: GetApiV1SerievideoVideoidLangsIdQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerievideoVideoidLangsIdQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerievideoVideoidLangsId401
      | GetApiV1SerievideoVideoidLangsId404
      | GetApiV1SerievideoVideoidLangsId500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerievideoVideoidLangsIdUrl(videoId, id).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
